import { call, put, takeEvery } from 'redux-saga/effects'
import { privateFetch } from '../../../fetch'
import { generalDoFailure } from '../../../util/fetchFailure'

import {
  createKegCollectionBookingRequest,
  createKegCollectionBookingSuccess,
  createKegCollectionBookingFailure,
} from './utils'

import { API_URL_PATH_KEG_COLLECTIONS } from '../../../../../constants'
import { CREATE_KEG_COLLECTION_REQUEST } from '../../../../actions/actionTypes'

function* createKegCollectionRequestWorker(action) {
  if (!action.payload) return
  const { kegCollectionRequestAPIParams } = action.payload || {}

  yield put(createKegCollectionBookingRequest())
  try {
    yield call(privateFetch, {
      path: API_URL_PATH_KEG_COLLECTIONS,
      method: 'POST',
      data: kegCollectionRequestAPIParams,
    })
    yield put(createKegCollectionBookingSuccess())
  } catch (error) {
    yield call(generalDoFailure, {
      error,
      action: createKegCollectionBookingFailure(error),
    })
  }
}

export default [
  [takeEvery, CREATE_KEG_COLLECTION_REQUEST, createKegCollectionRequestWorker],
]
